import React, { useCallback } from 'react'
import VideoDuration from 'Components/video/video-duration'
import AuthorAvatar from 'Components/author/author-avatar'
import VideoStats from 'Components/video/video-stats'
import LiveBox from 'Components/video/live-box'
import LiveTag from 'Components/video/live-tag'
import { ILiveRoomItem } from '../../services/home'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image, ImageStyles, ImageZoom } from 'Components/view-image'
import CommonCard from 'Components/new/common-card'

interface IProps {
  className?: string
  order?: number
  activeIndex?: number
  data: ILiveRoomItem
  [key: string]: any
}

const Item: React.FC<IProps> = ({ data, activeIndex, order }) => {
  const handleClick = useCallback(() => {
    sendTeaCommEvent('clk_event', {
      page_id: 'page_main_new',
      event_id: 'live_module_live_item',
      module_id: 'live_module',
      room_id: data.room_id,
      anchor_id: data.user_id,
      rank: `${activeIndex}`,
      item_rank: typeof order === 'number' ? `${order}` : '',
    })
  }, [data.room_id, data.user_id, activeIndex, order])

  return (
    <CommonCard
      className="tw-pb-24"
      type={'live'}
      id={data?.room_id}
      webRid={data?.web_rid}
      collectVisible={false}
      title={data?.title}
      popularity={data?.popularity}
      coverUrl={data?.cover_url}
      userId={data?.user_id}
      avatar={data?.avatar}
      username={data?.user_name}
      userVerified={data?.user_verified}
      onClick={handleClick}
      onClickUser={() => {
        sendTeaCommEvent('clk_event', {
          page_id: 'page_main_new',
          event_id: 'live_module_profile',
          module_id: 'live_module',
          room_id: data.room_id,
          anchor_id: data.user_id,
          rank: `${activeIndex}`,
          item_rank: typeof order === 'number' ? `${order}` : '',
        })
      }}
    />
  )
}

export default Item
